import axios, { AxiosRequestConfig, Method } from 'axios'
import { TL } from 'tz-geo-currency'
import { useStore } from '~/stores/main'
import { refreshUserToken, throwError } from '~/composables/useFunctions'

export enum ApiIdentifier {
  STORE_API = 'storeAPI',
  MIIO_API = 'miioAPI',
  STRAPI_CMS = 'strapiCMS',
  SERVICES_API = 'servicesAPI'
}

export async function requestData(api: ApiIdentifier, endpoint: string, method?: Method, payload?: object) {
  const store = useStore()
  const runtimeConfig = useRuntimeConfig()
  const userCookie = useCookie('hasUser')
  const logoutCookie = useCookie('logout')
  const authToken = useCookie('authToken')

  let data = null
  let error = null

  let apiURL: string

  let headers = store.headers

  if (store.firebaseUser) {
    await refreshUserToken()
  }

  if (userCookie.value && authToken.value) {
    headers = { ...headers, 'X-TOKEN': authToken.value }
  }

  switch (api) {
    case ApiIdentifier.STORE_API:
      apiURL = runtimeConfig.public.storeAPI
      headers.Authorization = !userCookie.value && store.tokens && store.tokens.store ? store.tokens.store : null
      break
    case ApiIdentifier.MIIO_API:
      apiURL = runtimeConfig.public.miioAPI
      break
    case ApiIdentifier.SERVICES_API:
      apiURL = runtimeConfig.public.servicesAPI
      headers.Authorization = !userCookie.value && store.tokens && store.tokens.services ? store.tokens.services : null
      break
    case ApiIdentifier.STRAPI_CMS:
      apiURL = runtimeConfig.public.strapiCMS
      headers = {}
      break
    default:
      throw new Error('Invalid API identifier')
  }

  const config: AxiosRequestConfig = {
    headers,
    method: method || 'GET',
    data: payload || {}
  }

  if (!store.firebaseUser && api === ApiIdentifier.STORE_API) {
    let countryCode = 'PT'
    try {
      countryCode = TL.getCountry()
    } catch (e) {
      throwError(e)
    }
    config.params = { ...config.params, country_code: countryCode }
  }

  try {
    const response = await axios({
      method: config.method,
      url: `${apiURL}/${endpoint}`,
      data: ['POST', 'PUT', 'PATCH'].includes(config.method) ? config.data : undefined,
      ...config
    })

    data = response.data
  } catch (e: unknown) {
    if (axios.isAxiosError(e)) {
      error = e.response
    } else {
      error = { message: 'Unknown error' }
    }
    if (e?.response?.status === 401) {
      if (logoutCookie.value) return
      reloadNuxtApp({ path: '/' })
    }
  }
  return {
    data,
    error
  }
}
